<template>
  <div class="drop user_join_drop" :class="{ active: let_in_drop }">
    <p v-if="$store.state.meeting.waitingParticipants.length == 1">
      {{ waitingParticipants[0].name }}
      is about to join a room
    </p>

    <p v-if="$store.state.meeting.waitingParticipants.length > 1">
      <button
        class="peoples"
        @click="$store.commit('showModal', 'people_modal')"
      >
        {{ $store.state.meeting.waitingParticipants.length }} people
      </button>
      requested to join.
    </p>

    <template v-if="$store.state.meeting.waitingParticipants.length == 1">
      <button
        class="color_btn hover_op"
        @click="grantAccess(waitingParticipants[0].id), (let_in_drop = false)"
      >
        Let in
      </button>

      <button
        class="hover_op decline"
        @click="denyAccess(waitingParticipants[0].id), (let_in_drop = false)"
      >
        Decline
      </button></template
    >

    <template v-if="$store.state.meeting.waitingParticipants.length > 1">
      <button
        class="color_btn hover_op"
        @click="letAllIn(waitingParticipants), (let_in_drop = false)"
      >
        Let all in
      </button>

      <button
        class="hover_op decline"
        @click="DeclineAll(waitingParticipants), (let_in_drop = false)"
      >
        Decline all
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: "userJoininDrop",

  data() {
    return {
      let_in_drop: false,
    };
  },

  methods: {
    grantAccess(id) {
      this.$store.dispatch("updateWaitingParticipant", {
        id: id,
        grantRequestedAccess: true,
      });
    },

    denyAccess(id) {
      this.$store.dispatch("updateWaitingParticipant", {
        id: id,
        grantRequestedAccess: false,
      });
    },

    letAllIn(waitingParticipants) {
      waitingParticipants.forEach((element) => {
        this.grantAccess(element.id);
      });
    },

    DeclineAll(waitingParticipants) {
      waitingParticipants.forEach((element) => {
        this.grantAccess(element.id);
      });
    },
  },

  computed: {
    waitingParticipants() {
      if (this.$store.state.meeting.waitingParticipants.length > 0) {
        this.let_in_drop = true;
      }
      return this.$store.state.meeting.waitingParticipants;
    },

    meetingState() {
      return this.$store.state.meeting.currentState;
    },
  },
};
</script>

<style lang="scss" scoped>
.user_join_drop {
  left: 0;
  padding: 0 !important;
  .color_btn {
    width: 358px;
    margin-left: 32px;
    margin-right: 32px;
    background-color: #fc5a12;

    @media all and (max-width: 767px) {
      margin-left: 16px;
      margin-right: 16px;
    }
  }

  @media all and (max-width: 767px) {
    width: 100%;
    left: 0;
    right: 0;
    top: 32px;
  }

  p {
    word-break: break-all;
    padding: 32px;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;

    @media all and (max-width: 767px) {
      margin-bottom: 16px;
    }
  }

  button {
    text-align: center !important;

    & + button {
      margin-top: 16px;
    }

    @media all and (max-width: 815px) {
      width: 100%;
    }
  }

  .decline {
    margin-bottom: 32px;
  }
  .color_btn {
    color: #fff;
  }

  .peoples {
    width: auto;
    height: auto;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    padding-left: 0;
    padding-right: 0;
    display: inline-block;
    color: #fc5a12;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
